import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UtilityBarHelperService {

  private _refreshUtilityBarReference: Subject<boolean> = new Subject<boolean>();

  constructor() { }

  public utilityBerRefRefreshWatch(): Observable<boolean> {
    return this._refreshUtilityBarReference;
  }

  public triggerUtilityBarRefresh(): void {
    this._refreshUtilityBarReference.next(true);
  }

}
